import { type FC, type ReactNode } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { Popover, TextLink } from '@eneco/sparky';
import { InfoIcon } from '@eneco/sparky/icons';

interface InfoPopoverProps {
  title: string;
  content: ReactNode;
  size?: 'small' | 'large';
}

export const InfoPopover: FC<InfoPopoverProps> = ({ title, content, size = 'large' }) => (
  <Popover
    size={size}
    side="bottom"
    title={title}
    trigger={<TextLink leftIcon={<InfoIcon size="small" verticalAlign="text-top" color="currentColor" />}>{''}</TextLink>}>
    {typeof content === 'string' ? <RichText html={content} /> : content}
  </Popover>
);
